import React, { useState } from 'react';

import SportAthletesCreateForm from './SportAthletesCreateForm';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function SportAthletesCreateModal(props) {
    const [sportAthleteIsUpdated, setSportAthleteIsUpdated] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setSportAthleteIsUpdated(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Create Sport Athlete')} close={props.closeHandler}></ModalHeader>
                    <div className="tw-rounded-b">
                        <div className="modal__form-container">
                            <div className={!sportAthleteIsUpdated && !requestFailed ? 'modal__form-container' : 'hidden'}>
                                <SportAthletesCreateForm
                                    nationalities={props.nationalities}
                                    sportAthletesStoreUrl={props.sportAthletesStoreUrl}
                                    internalCloseHandler={internalCloseHandler}
                                    setSportAthleteIsUpdated={setSportAthleteIsUpdated}
                                    request={request}
                                />
                            </div>
                            <div className={sportAthleteIsUpdated ? 'tw-grid tw-grid-cols-1' : 'tw-grid tw-grid-cols-1 hidden'}>
                                <label className="modal__msg modal__text-color">{$t('Athlete created')}</label>
                            </div>
                            <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'tw-grid tw-grid-cols-1 hidden'}>
                                <label className="modal__msg modal__error-text-color">{$t('Athlete could not be created')}</label>
                            </div>

                            {(sportAthleteIsUpdated || requestFailed) && (
                                <div className="modal__footer">
                                    <Button variant="secondary" onClick={internalSuccessHandler}>
                                        {$t('Close')}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
